import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { IdentityUserService } from '@volo/abp.ng.identity/proxy';
import { IncidentCauseService, IncidentDetectionService, IncidentOriginService, IncidentTypeService, IntensityDegreeService, MainDiagnosisService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

export const INCIDENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isAuthorized', 'Entity.Incident.IsAuthorized')
    .build(),
  FieldBuilder
    .date('incidentDate', 'Entity.Incident.IncidentDate')
    .required()
    .build(),
  FieldBuilder
    .number('area', 'Entity.Incident.Area')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .text('notes', 'Entity.Incident.Notes')
    .maxLength(256)
    .build(),
  FieldBuilder
    .number('oldIncidentReference', 'Entity.Incident.OldIncidentReference')
    .build(),
  FieldBuilder
    .number('number', 'Entity.Incident.Number')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'incidentTypeId',
    'Entity.IncidentType',
    IncidentTypeService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'incidentCauseId',
    'Entity.IncidentCause',
    IncidentCauseService
  )
    .required()
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'intensityDegreeId',
    'Entity.IntensityDegree',
    IntensityDegreeService
  )
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'incidentOriginId',
    'Entity.IncidentOrigin',
    IncidentOriginService
  )
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'incidentDetectionId',
    'Entity.IncidentDetection',
    IncidentDetectionService
  )
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'userId',
    'Entity.Incident.User',
    IdentityUserService
  )
    .required()
    .displayFromNested('abpUsers.name')
    .sortBy('abpUsers.name')
    .build(),
  FieldBuilder.foreignKey(
    'authorizationUserId',
    'Entity.Incident.AuthorizationUser',
    IdentityUserService
  )
    .displayFromNested('abpUsers.name')
    .sortBy('abpUsers.name')
    .build(),
  FieldBuilder.foreignKey(
    'mainDiagnosisId',
    'Entity.MainDiagnosis',
    MainDiagnosisService
  )
    .display('name')
    .keyField('id')
    .build(),
];

export const INCIDENT_CONFIG = {
  entityName: 'Incident',
  localizationKey: 'Operational::Entity.Incident',
  fields: INCIDENT_FIELDS,
  permission: 'PlanningOperation.Incidents',
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Quality + MENU_NAME_SUFFIX,
  menuSubcategory: '',
};
